import React from 'react'

const ModelContext = React.createContext(null)

export default ModelContext
